import { Action } from 'infra/types'
import { SeedPhase } from './seed.types'

export const SeedAction = {
  SEED_TRANSACTIONS: 'seed/SEED_TRANSACTIONS',
  SEED_STARTED: 'seed/SEED_STARTED',
  SEED_PHASE: 'seed/SEED_PHASE',
  SEED_SUCCESS: 'seed/SEED_SUCCESS',
  SEED_FAILURE: 'seed/SEED_FAILURE',
  SKIP_SEED: 'seed/SKIP_SEED',
  RESET_SEED_STATE: 'seed/RESET_SEED_STATE'
}

export interface ISeedTriggerPayload {
  businessId: string
  isActive: boolean
}

/** Trigger a seed for a business. `isActive` (default true) means foreground/blocking. */
export const seedTransactions = (payload: {
  businessId: string
  isActive?: boolean
}): Action<ISeedTriggerPayload> => ({
  type: SeedAction.SEED_TRANSACTIONS,
  payload: { businessId: payload.businessId, isActive: payload.isActive !== false }
})

export const seedStarted = (payload: {
  businessId: string
  isActive: boolean
}): Action<{ businessId: string; isActive: boolean }> => ({
  type: SeedAction.SEED_STARTED,
  payload
})

export const seedPhase = (payload: {
  businessId: string
  phase: SeedPhase
  entryCount?: number
}): Action<{ businessId: string; phase: SeedPhase; entryCount?: number }> => ({
  type: SeedAction.SEED_PHASE,
  payload
})

export const seedSuccess = (payload: { businessId: string }): Action<{ businessId: string }> => ({
  type: SeedAction.SEED_SUCCESS,
  payload
})

export const seedFailure = (payload: {
  businessId: string
  error: string
}): Action<{ businessId: string; error: string }> => ({
  type: SeedAction.SEED_FAILURE,
  payload
})

export const skipSeed = (payload: { businessId: string }): Action<{ businessId: string }> => ({
  type: SeedAction.SKIP_SEED,
  payload
})

export const resetSeedState = (): Action<null> => ({
  type: SeedAction.RESET_SEED_STATE,
  payload: null
})
